import classNames from "classnames/bind";
import React from "react";
import { Icon } from "../../../Icon";
import { Skeleton } from "../../../Skeleton";
import styles from "./InvalidInputMessage.module.scss";
import type { InvalidInputMessageProps } from "./types";

const cx = classNames.bind(styles);

/**
 * Message to display next to an input when it is invalid. The message is meant
 * to explain why the input is invalid and what to do about it.
 *
 * Pass the message in as children, but note it is in a span within a p tag.
 */
export const InvalidInputMessage = ({
  intent = "error",
  children,
  isLoading,
  isBusy,
  isInline = true,
  isDisabled = false,
  colorScheme = "light",
  ...restProps
}: InvalidInputMessageProps) => {
  return (
    <p
      aria-live="polite"
      {...restProps}
      className={cx(
        "container",
        intent,
        { "container--inline": isInline },
        restProps.className
      )}
      aria-disabled={isDisabled}
      role="alert"
    >
      <Icon
        variant={intent === "error" ? "warning-octagon" : "warning"}
        size={16}
        className={cx("icon")}
      />
      <Skeleton
        isLoading={isLoading}
        isBusy={isBusy}
      >
        <span className={cx("message")}>{children}</span>
      </Skeleton>
    </p>
  );
};
